var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "a",
        {
          staticClass: "notification-link",
          attrs: { href: "/notifications/bids" },
          on: {
            click: function($event) {
              return _vm.onClickBids()
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: "/images/auction-blue.svg",
              alt: "Bid notifications",
              width: "28"
            }
          }),
          _vm._v(" "),
          _vm.unread_bids_count
            ? _c(
                "b-badge",
                { class: _vm.unread_bids_count > 9 ? "small-text" : "" },
                [_vm._v(_vm._s(_vm.unread_bids_count))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.$refs && _vm.$refs["bids_button"]
        ? _c(
            "b-popover",
            {
              attrs: {
                target: _vm.bids_target,
                triggers: "focus",
                placement: "bottomleft",
                title: "Bid notifications"
              }
            },
            [
              _c(
                "div",
                { staticClass: "notifications-popper" },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "/notifications/bids" },
                      on: { click: _vm.onRouteClick }
                    },
                    [_vm._v("\n                View all\n            ")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.bids, function(notification, i) {
                    return [
                      notification.data.title && i < 10
                        ? _c(
                            "div",
                            { staticClass: "notification" },
                            [
                              notification.data.route
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: notification.data.route },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRouteClick(notification)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "title" }, [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(notification.data.title) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      notification.data.message
                                        ? _c(
                                            "div",
                                            { staticClass: "message" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    notification.data.message
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(notification.data.title) +
                                        "\n                        "
                                    ),
                                    notification.data.message
                                      ? _c("div", { staticClass: "message" }, [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                notification.data.message
                                              ) +
                                              "\n                        "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  }),
                  _vm._v(" "),
                  !_vm.bids || _vm.bids_count.length === 0
                    ? _c("div", [
                        _vm._v(
                          "\n                You have no notifications\n            "
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "notification-link",
          attrs: { href: "/notifications/bid_messages" },
          on: {
            click: function($event) {
              return _vm.onClickMsg()
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: "/images/request-blue.svg",
              alt: "Bid message notifications",
              width: "28"
            }
          }),
          _vm._v(" "),
          _vm.unread_bid_messages_count
            ? _c(
                "b-badge",
                {
                  class: _vm.unread_bid_messages_count > 9 ? "small-text" : ""
                },
                [_vm._v(_vm._s(_vm.unread_bid_messages_count))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.$refs && _vm.$refs["message_button"]
        ? _c(
            "b-popover",
            {
              attrs: {
                target: _vm.messages_target,
                triggers: "focus",
                placement: "bottomleft",
                title: "Bid message notifications"
              }
            },
            [
              _c(
                "div",
                { staticClass: "notifications-popper" },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "/notifications/bid_messages" },
                      on: { click: _vm.onRouteClick }
                    },
                    [_vm._v("\n                View all\n            ")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.bid_messages, function(notification, i) {
                    return [
                      notification.data.title && i < 10
                        ? _c(
                            "div",
                            { staticClass: "notification" },
                            [
                              notification.data.route
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: notification.data.route },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRouteClick(notification)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "title" }, [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(notification.data.title) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      notification.data.message
                                        ? _c(
                                            "div",
                                            { staticClass: "message" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    notification.data.message
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(notification.data.title) +
                                        "\n                        "
                                    ),
                                    notification.data.message
                                      ? _c("div", { staticClass: "message" }, [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                notification.data.message
                                              ) +
                                              "\n                        "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  }),
                  _vm._v(" "),
                  !_vm.bids || _vm.bids_count.length === 0
                    ? _c("div", [
                        _vm._v(
                          "\n                You have no notifications\n            "
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-301fba8f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-301fba8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/Notifications.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-301fba8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/Notifications.vue
// module chunks = 0